export type ScheduleTemplateReviewStatus =
    | 'NOT_APPLICABLE'
    | 'PENDING'
    | 'COMPLETE'

export type TurnSetupStatus =
    | 'No Project'
    | 'Draft'
    | 'Confirmed · Not Scheduled'
    | 'Needs Schedule Review'
    | 'Setup Complete'

export const TURN_SETUP_STATUSES: TurnSetupStatus[] = [
    'No Project',
    'Draft',
    'Confirmed · Not Scheduled',
    'Needs Schedule Review',
    'Setup Complete',
]

export interface TurnSetupStatusInput {
    review_status?: string | null
    schedule_review_status?: ScheduleTemplateReviewStatus | string | null
    project_scheduled?: boolean | null
}

/**
 * Composed turn-setup progress for Manage Turn Projects.
 *
 * Order: No Project → Needs Schedule Review → Draft →
 * Confirmed · Not Scheduled → Setup Complete.
 */
export function getTurnSetupStatus(
    project: TurnSetupStatusInput | null | undefined,
): TurnSetupStatus {
    if (project == null) {
        return 'No Project'
    }

    if (project.schedule_review_status === 'PENDING') {
        return 'Needs Schedule Review'
    }

    if (project.review_status === 'DRAFT') {
        return 'Draft'
    }

    if (!project.project_scheduled) {
        return 'Confirmed · Not Scheduled'
    }

    return 'Setup Complete'
}
